<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="420" min-width="320" max-width="320" nudge-bottom="8" z-index="11")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="currentProvider" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold {{ $t('doctor') }}
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ currentProvider.label }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ $t('doctor') }}
    
    .white
      .menu-header.white
        .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} {{ $t('doctor').toLowerCase() }}
        v-text-field.text-sm.round-xl.mx-4.mb-3(v-model="searchText" @input="queryChanged" outlined :placeholder="$t('search')" dense hide-details)
        v-divider

      v-skeleton-loader.pa-4(v-if="isLoading" type="text@3")
      div(v-else)
        template(v-if="providers.length > 0")
          v-radio-group.mx-0.mt-0(v-model="selectedProvider" hide-details)
            template(v-for="provider in providers")
              v-radio.px-4.py-1.mt-2(:value="provider")
                template(v-slot:label)
                  .text-sm.font-normal.primary--text {{ provider.label }}
              v-divider.basic300
        template(v-else)
          .text-center.py-8.text-xs.neutral500--text {{ $t('no_doctors_found') }}
          
    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="!disabledClear" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledApply") {{ $t('apply') }}

</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['filter'],
  components: {},
  data: () => ({
    showMenu: false,
    isLoading: true,
    searchText: '',
    providers: [],
    currentProvider: null,
    selectedProvider: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    disabledApply () {
      if (this.selectedProvider === null) return true

      if (this.currentProvider) return this.selectedProvider.value === this.currentProvider.value

      return false
    },
    disabledClear () {
      return this.selectedProvider === null
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
    showMenu (value) {
      if (value && this.currentProvider) {
        this.selectedProvider = { ...this.currentProvider }
      }
    }
  },
  mounted () {
    this.fetchProviders()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchProviders () {
      this.isLoading = true
      const params = {
        fields: 'name,member',
        page_size: -1,
        search: this.searchText || ''
      }
      this.$axios.get(`/clinics/${this.company.slug}/providers`, { params })
      .then(resp => {
        if (resp.data?.results) {
          this.providers = resp.data.results.map(item => {
            return {
              label: item.name,
              value: `${item.member}`
            }
          })
        } else {
          this.providers = []
        }
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.selectedProvider = null
      this.currentProvider = null
    },
    apply () {
      this.showMenu = false
      this.currentProvider = { ...this.selectedProvider }
      this.$emit('update:filter', { key: 'member', value: this.selectedProvider.value })
    },
    queryChanged: debounce(function () {
      this.fetchProviders()
    }, 750),
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
.menu-header {
  top: 0;
  position: sticky;
  z-index: 1;
}
</style>